import { useForm } from 'react-hook-form';
import { FORM_SEARCH, searchDefaultValues } from '../form';
import { columns } from '../columns';
import { useGetReportCampaignByDate } from './useGetReportCampaignByDate';
import { useEffect, useState } from 'preact/hooks';
import { useGetReportCampaignFull } from './useGetReportCampaignFull';

export const useGetReportCampaign = () => {
  const [searchType, setSearchType] = useState(null);
  const formSearchObj = useForm({ defaultValues: searchDefaultValues });

  const {
    dataSource: campaignData,
    onFetch,
    isLoading: loading,
  } = useGetReportCampaignByDate({
    handleSubmit: formSearchObj.handleSubmit,
  });

  const {
    dataSource: campaignDataFull,
    onFetchFull,
    loading: loadingFull,
  } = useGetReportCampaignFull({
    handleSubmit: formSearchObj.handleSubmit,
  });

  useEffect(() => {
    onSearchByField(searchDefaultValues);
  }, []);

  const onSearchByField = (values) => {
    if (values.search) {
      setSearchType('search');
      onFetchFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onFetch(values);
    }
  };

  const formatDataForExcel = (data) => {
    return data.map((record) => ({
      ลำดับ: record.rowNumber,
      Partner: record.partnerName,
      'ชื่อ Campaign': record.campaignName,
      รหัสคูปอง: record.rawCode,
      สถานะ: record.campaignPoolStatusName,
      'ชื่อ-นามสกุล': record.fullName,
      เบอร์โทร: record.telephone,
      รหัสลงทะเบียน: record.warrantyCode,
      'รหัส Warranty': record.warrantyNumberCode,
      วันที่เริ่มต้น: record.startDate,
      วันที่หมดอายุ: record.expiredDate,
      'วันที่ใช้สิทธิ์': record.usedDate,
      Description: record.description,
    }));
  };

  const columnData = columns();
  const formSearch = FORM_SEARCH({ onEnter: formSearchObj.handleSubmit(onSearchByField) });

  return {
    formSearchObj,
    formSearch,
    columnData,
    campaignData,
    campaignDataFull,
    searchType,
    onSearchByField,
    loadingFull,
    loading,
    formatDataForExcel,
  };
};
